import axios from 'axios';
import { ADD_BANK_ENDPOINT, API_CALL_ERROR, BANK_LIST_ENDPOINT, DELETE_BANK_ENDPOINT, UPDATE_BANK_ENDPOINT } from './_ConstantsAPI';



export async function getBankList(branchId) {
    try {
      const { data } = await axios.get(BANK_LIST_ENDPOINT, {
        params: {
          branchId: branchId,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return data;
    } catch (error) {
      
      return { isSuccessful: false, data: API_CALL_ERROR };
    }
  }




  export async function addBank(payload) {
    try {
      
      const { data } = await axios.post(ADD_BANK_ENDPOINT, payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      return data;
    } catch (error) {
      return { isSuccessful: false, data: API_CALL_ERROR };
    }
  }



  export async function updateBank(payload) {
    console.log(payload);
    try {
      
      const { data } = await axios.post(UPDATE_BANK_ENDPOINT, payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      return data;
    } catch (error) {
      
      return { isSuccessful: false, data: API_CALL_ERROR };
    }
  }
  
  export async function deleteBank(payload) {
    try {
      const { data } = await axios.post(DELETE_BANK_ENDPOINT, payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      return data;
    } catch (error) {
      
      return { isSuccessful: false, data: API_CALL_ERROR };
    }
  }